/**
* http.js
* 封装axios，    通过store 定义全局loading状态
* 调用方法:
* http.get('/api/enquiry/web/query',{id:1}).then((res)=>{你的操作})
* http.post('/api/enquiry/web/update',{id:1}).then((res)=>{你的操作})
* http.postFormData('/api/enquiry/web/update',{id:1,file:file}).then((res)=>{你的操作})
*/
import axios from 'axios'
import qs from 'qs'
// import { state }  from '@/store/index.js'
import cache from './cache'
import { Message } from 'element-ui';
import utils from '../utils/utils';
import config from '../utils/config.js'
// axios.defaults.baseURL ="http://localhost:8052"
// axios.defaults.headers.common.Authorization = cache.getStr("token")

  // 响应拦截
axios.interceptors.response.use((res) => {
    const { status, data, statusText } = res;
    // console.info(res)
    // if (status === 200 || status === 201) {
        
    //   return res;
    // }
    return res;

},
(error)  =>{
    console.error(error)
    const res = error.response
   
    if (res&& res.status === 401) {
        // ElMessage.error( TOKEN_INVALID);
        console.info("401跳转")
        // window.location = "/#/login";
        // let routerUrl =window.location.href

        // if(window )
        // {
        //  console.info(encodeURIComponent(routerUrl))
        //   window.location = "/login?forward="+encodeURIComponent(routerUrl);
        // }
        return Promise.reject(error)
    }
    else{
      console.info( error.response.data)
      return Promise.reject(error)
    }

}
)

export default {







 /**
  * get方法，对应get请求
  * @param {String} url [请求的url地址]
  * @param {Object} params [请求时携带的参数]
  */
 get (url, params,context) {
  // params.language = localStorage.language
  let Timestamp  =  new Date().getTime()

  let Signature  = utils.genSignature(url, params,Timestamp,false,"GET")
 
   return new Promise((resolve, reject) => {
     axios.get(url,
      {params:params,
        headers:{
          "Authorization": cache.getStr("token")?cache.getStr("token"):"",
          "AppKey": process.env.VUE_APP_APP_KEY,
          "Timestamp":Timestamp,
          "Signature":Signature,
          "TenantId":config.TenantId,
          "lang": cache.getStr("lang")?cache.getStr("lang"):"en",
          "Accept-Language": cache.getStr("lang")?cache.getStr("lang"):"en",
          "countryCode":utils.launageToCountryCode(cache.getStr(config.lang)) ,

        }
      }
     ).then(res => {
     
       resolve(res.data)
     }).catch(err => {
      console.error(err)
      Message(`${err.response.data.message}`)
       reject(err)
     })
   })
 },

 deleteFrom (url, params,context) {
  // params.language = localStorage.language
  let Timestamp  =  new Date().getTime()
  let Signature  = utils.genSignature(url, params,Timestamp,false,"DELETE")
 
   return new Promise((resolve, reject) => {
     axios.delete(url,
      {params:params,
        headers:{
          "Authorization": cache.getStr("token")?cache.getStr("token"):"",
          "AppKey":process.env.NUXT_ENV.APP_KEY,
          "Timestamp":Timestamp,
          "Signature":Signature,
          "TenantId":cache.getStr(config.tenantId)?cache.getStr(config.tenantId):config.aigoTenantId,
          "content-type": "application/x-www-form-urlencoded",
          "countryCode":utils.launageToCountryCode(cache.getStr(config.countryCode)) ,
          "lang": cache.getStr(config.lang)?cache.getStr(config.lang):"en",
          "Accept-Language": cache.getStr(config.lang)?cache.getStr(config.lang):"en",
          brand: cache.getStr(config.brandKey),
          // 'X-User': "ewogICJpc3MiOiAiaHR0cHM6Ly90ZXN0LnVjLmFpZ29zdGFyLmNvbTozNDQzIiwKICAidXNlcl9pZCI6ICIxNjMxMTM1NzgxMzE1ODA5MjgwIiwKICAib3JnX2lkIjogIjEwMDAiLAogICJvcmdfdXNlcl9pZCI6ICIxMDEyOTYiLAogICJ1c2VybmFtZSI6ICJhM2xiaHI3IiwKICAibGVnYWxfbmFtZSI6ICJhM2xiaHI3IiwKICAicGhvbmVfbnVtYmVyIjogIiIsCiAgImVtYWlsIjogIiIsCiAgImNvdW50cnlfY29kZSI6ICJJVCIKfQ==",
          //    'X-Iss': "https://test.uc.aigostar.com:3443", 
        }
      }
     ).then(res => {
     
       resolve(res.data)
     }).catch(err => {
    
      Message(`${err.response.data.message}`)
       reject(err)
     })
   })
 },
 delete (url, params,context) {
  // params.language = localStorage.language
  let Timestamp  =  new Date().getTime()
  let Signature  = utils.genSignature(url, params,Timestamp,false,"DELETE")
 
   return new Promise((resolve, reject) => {
     axios.delete(url,
      {data:params,
        headers:{
          "Authorization": cache.getStr("token")?cache.getStr("token"):"",
          "AppKey":process.env.NUXT_ENV.APP_KEY,
          "Timestamp":Timestamp,
          "Signature":Signature,
          "TenantId":cache.getStr(config.tenantId)?cache.getStr(config.tenantId):config.aigoTenantId,
          "countryCode":utils.launageToCountryCode(cache.getStr(config.countryCode)) ,
          "lang": cache.getStr(config.lang)?cache.getStr(config.lang):"en",
          "Accept-Language": cache.getStr(config.lang)?cache.getStr(config.lang):"en",
          brand: cache.getStr(config.brandKey),
          // 'X-User': "ewogICJpc3MiOiAiaHR0cHM6Ly90ZXN0LnVjLmFpZ29zdGFyLmNvbTozNDQzIiwKICAidXNlcl9pZCI6ICIxNjMxMTM1NzgxMzE1ODA5MjgwIiwKICAib3JnX2lkIjogIjEwMDAiLAogICJvcmdfdXNlcl9pZCI6ICIxMDEyOTYiLAogICJ1c2VybmFtZSI6ICJhM2xiaHI3IiwKICAibGVnYWxfbmFtZSI6ICJhM2xiaHI3IiwKICAicGhvbmVfbnVtYmVyIjogIiIsCiAgImVtYWlsIjogIiIsCiAgImNvdW50cnlfY29kZSI6ICJJVCIKfQ==",
          //    'X-Iss': "https://test.uc.aigostar.com:3443", 
        }
      }
     ).then(res => {
     
       resolve(res.data)
     }).catch(err => {
    
      Message(`${err.response.data.message}`)
       reject(err)
     })
   })
 },
 patch (url, params) {
  // params.language = localStorage.language
  let Timestamp  =  new Date().getTime()
  let Signature  = utils.genSignature(url, params,Timestamp,true,"PATCH")
 
   return new Promise((resolve, reject) => {
     axios.patch(url,params,
      {
        headers:{
          "Authorization": cache.getStr("token")?cache.getStr("token"):"",
          "AppKey":process.env.NUXT_ENV.APP_KEY,
          "Timestamp":Timestamp,
          "Signature":Signature,
          "TenantId":cache.getStr(config.tenantId)?cache.getStr(config.tenantId):config.aigoTenantId,
          "lang": cache.getStr(config.lang)?cache.getStr(config.lang):"en",
          "Accept-Language": cache.getStr(config.lang)?cache.getStr(config.lang):"en",
          "countryCode":utils.launageToCountryCode(cache.getStr(config.countryCode)) ,
          brand: cache.getStr(config.brandKey),
          // 'X-User': "ewogICJpc3MiOiAiaHR0cHM6Ly90ZXN0LnVjLmFpZ29zdGFyLmNvbTozNDQzIiwKICAidXNlcl9pZCI6ICIxNjMxMTM1NzgxMzE1ODA5MjgwIiwKICAib3JnX2lkIjogIjEwMDAiLAogICJvcmdfdXNlcl9pZCI6ICIxMDEyOTYiLAogICJ1c2VybmFtZSI6ICJhM2xiaHI3IiwKICAibGVnYWxfbmFtZSI6ICJhM2xiaHI3IiwKICAicGhvbmVfbnVtYmVyIjogIiIsCiAgImVtYWlsIjogIiIsCiAgImNvdW50cnlfY29kZSI6ICJJVCIKfQ==",
          // 'X-Iss': "https://test.uc.aigostar.com:3443", 

        }
      }
     ).then(res => {
     
       resolve(res.data)
     }).catch(err => {
      
      Message(`${err.response.data.message}`)
       reject(err)
     })
   })
 },
 /**
  * post方法，对应post请求
  * @param {String} url [请求的url地址]
  * @param {Object} params [请求时携带的参数]
  * isShowErro  是否要显示错误信息
  */
 post (url, params,isShowErro=true) {
  // params.language = localStorage.language
  let Timestamp  =  new Date().getTime()
  let Signature  = utils.genSignature(url, params,Timestamp,true)
  //  console.info(cache.getStr("token"))
   return new Promise((resolve, reject) => {
     axios.post(url, params,
      {
        headers:{
          "Authorization": cache.getStr("token")?cache.getStr("token"):"",
          "AppKey": process.env.VUE_APP_APP_KEY,
          "Timestamp":Timestamp,
          "Signature":Signature,
          "TenantId":config.TenantId,
          "lang": cache.getStr("lang")?cache.getStr("lang"):"en",
          "Accept-Language": cache.getStr("lang")?cache.getStr("lang"):"en",
          "countryCode":utils.launageToCountryCode(cache.getStr(config.lang)) ,
          brand: cache.getStr(config.brandKey),

        }
      }
      )
       .then(res => {

         resolve(res.data)
       })
       .catch(err => {
        if(isShowErro)
        Message(`${err.response.data.message}`)
         reject(err)
       })
   })
 },
 put (url, params,isShowErro=true) {
  // params.language = localStorage.language
  let Timestamp  =  new Date().getTime()
  let Signature  = utils.genSignature(url, params,Timestamp,true)
  //  console.info(cache.getStr("token"))
   return new Promise((resolve, reject) => {
     axios.put(url, params,
      {
        headers:{
          "Authorization": cache.getStr("token")?cache.getStr("token"):"",
          "AppKey":process.env.NUXT_ENV.APP_KEY,
          "Timestamp":Timestamp,
          "Signature":Signature,
          "TenantId":cache.getStr(config.tenantId)?cache.getStr(config.tenantId):config.aigoTenantId,
          "lang": cache.getStr(config.lang)?cache.getStr(config.lang):"en",
          "Accept-Language": cache.getStr(config.lang)?cache.getStr(config.lang):"en",
          "countryCode":utils.launageToCountryCode(cache.getStr(config.countryCode)) ,
          brand: cache.getStr(config.brandKey),
          // 'X-User': "ewogICJpc3MiOiAiaHR0cHM6Ly90ZXN0LnVjLmFpZ29zdGFyLmNvbTozNDQzIiwKICAidXNlcl9pZCI6ICIxNjMxMTM1NzgxMzE1ODA5MjgwIiwKICAib3JnX2lkIjogIjEwMDAiLAogICJvcmdfdXNlcl9pZCI6ICIxMDEyOTYiLAogICJ1c2VybmFtZSI6ICJhM2xiaHI3IiwKICAibGVnYWxfbmFtZSI6ICJhM2xiaHI3IiwKICAicGhvbmVfbnVtYmVyIjogIiIsCiAgImVtYWlsIjogIiIsCiAgImNvdW50cnlfY29kZSI6ICJJVCIKfQ==",
          //    'X-Iss': "https://test.uc.aigostar.com:3443", 
        }
      }
      )
       .then(res => {

         resolve(res.data)
       })
       .catch(err => {
        if(isShowErro)
        Message(`${err.response.data.message}`)
         reject(err)
       })
   })
 },
 //isShowErro  是否要显示错误信息
 postFrom (url, params,isShowErro=true) {
  // params.language = localStorage.language
  let Timestamp  =  new Date().getTime()
  let Signature  = utils.genSignature(url, params,Timestamp)

   return new Promise((resolve, reject) => {
     axios.post(url, qs.stringify(params),
      {
        headers:{
          "Authorization": cache.getStr("token")?cache.getStr("token"):"",
          "AppKey": process.env.VUE_APP_APP_KEY,
          "Timestamp":Timestamp,
          "Signature":Signature,
          "content-type": "application/x-www-form-urlencoded",
          "lang": cache.getStr(config.lang)?cache.getStr(config.lang):"en",
          "Accept-Language": cache.getStr(config.lang)?cache.getStr(config.lang):"en",
          "TenantId":config.TenantId,
          "countryCode":utils.launageToCountryCode(cache.getStr(config.lang)) ,
   
   
        }}
      )
       .then(res => {
        // res.sendRedirect(res.data)
         resolve(res.data)
       })
       .catch(err => {
        if(isShowErro)
        Message(`${err.response.data.message}`)
         reject(err)
       })
   })
 },

 /**
  * postFormData方法，对应post请求，用来提交文件+数据
  * @param {String} url [请求的url地址]
  * @param {Object} params [请求时携带的参数]
  */
 postFormData (url, params) {

   return new Promise((resolve, reject) => {
     axios({
       headers: {
         'Content-Type': 'multipart/form-data'// ;boundary=----WebKitFormBoundaryQ6d2Qh69dv9wad2u
       },
       transformRequest: [function (data) { // 在请求之前对data传参进行格式转换
         const formData = new FormData()
         Object.keys(data).forEach(key => {
           formData.append(key, data[key])
         })
         return formData
       }],
       url,
       method: 'post',
       data: params
     }).then(res => {
       resolve(res.data)
     }).catch(err => {
       reject(err)
     })
   })
 },

 postFileData(url,data){
  return axios.request({    // axios.request 方法是简单的对axios的封装，看这配置也应该不需要多介绍
      url,
      data,
      method: 'post',
      headers: { 'Content-Type': 'multipart/form-data','Accept':'*/*',"X-Requested-With": "XMLHttpRequest" }
    })

 }

}
